import React, { useState } from "react";
import CampaignEditor from "./CampaignEditor";

const CreateWhatsappCampaign = ({ fetchCampaigns, onClose, campaignType }) => {
  const [campaignName, setCampaignName] = useState("");
  const [isCampaignEditorOpen, setIsCampaignEditorOpen] = useState(false);

  // Render CampaignEditor if isCampaignEditorOpen is true
  if (isCampaignEditorOpen) {
    return (
      <CampaignEditor
        fetchCampaigns={fetchCampaigns}
        campaignName={campaignName}
        onClose={onClose}
        channel={campaignType === "whatsapp" ? "WhatsApp" : "Email"} // Pass channel dynamically
      />
    );
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-[1000] p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-2xl rounded-lg shadow-lg relative max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
            Create a {campaignType === "whatsapp" ? "WhatsApp" : "Email"}{" "}
            Campaign
          </h2>
          <button
            className="text-gray-500 hover:text-gray-800 text-xl p-1 hover:bg-gray-100 rounded-full transition-colors"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="max-w-md mx-auto">
            <h2 className="text-base sm:text-lg font-bold text-gray-800 mb-4">
              Create a {campaignType === "whatsapp" ? "WhatsApp" : "Email"}{" "}
              campaign
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              Reach out to your customers on{" "}
              {campaignType === "whatsapp" ? "WhatsApp" : "Email"}. Share
              important news, promote a line of products, announce an upcoming
              event.
            </p>

            {/* Campaign Name Input */}
            <label className="text-gray-700 text-sm font-medium block mb-2">
              How will you name your campaign? (only you can see it)
            </label>
            <div className="relative mb-6">
              <input
                type="text"
                value={campaignName}
                onChange={(e) => setCampaignName(e.target.value)}
                placeholder="Type the name of your campaign"
                maxLength={997}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-600 focus:outline-none text-sm sm:text-base"
              />
              <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                {campaignName.length}/997
              </span>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end items-center gap-3 sm:gap-4">
              <button
                onClick={onClose}
                className="w-full sm:w-auto text-purple-600 hover:underline text-sm font-medium order-2 sm:order-1"
              >
                Discard
              </button>
              <button
                onClick={() => setIsCampaignEditorOpen(true)} // Open CampaignEditor
                disabled={!campaignName}
                className={`w-full sm:w-auto px-6 py-2.5 text-white rounded-lg text-sm font-medium order-1 sm:order-2 transition-colors ${
                  campaignName
                    ? "bg-purple-600 hover:bg-purple-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                Start
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateWhatsappCampaign;
